<div class="auth-wrapper">
  <div class="auth-card">
    <div class="auth-card__header">
      <strong>RESET PASSWORD</strong>
    </div>

    <div class="form-container">
      <axis-form
        formType="passwordReset"
        [model]="model"
        [showLabels]="true"
        [headingOverride]="'Reset Password'"
        [formVariant]="'waitron-auth'"
        (formSubmit)="onFormSubmit($event)"
      ></axis-form>

      <div class="form-links">
        <p>
          Back to
          <a [routerLink]="['/login']" [queryParams]="loginQueryParams">
            Login
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
